import { __assign } from "tslib";
export function getUIHostParams(document, additionalParams) {
    if (additionalParams === void 0) { additionalParams = {}; }
    return __assign(__assign({}, additionalParams), { drive: document.driveId, item: document.docId, file: document.canonicalUrl });
}
//# sourceMappingURL=getUIHostParams.js.map